import React, { Component} from 'react';
import ReactDOM from 'react-dom';
import { createStore, applyMiddleware } from 'redux';
import axios from 'axios';
import { Provider } from 'react-redux';
import ReduxPromise from 'redux-promise';
import Logger from 'redux-logger';
import { HashRouter, Route, Switch } from 'react-router-dom';
import { IntlProvider } from "react-intl";
import { config } from "./constants/domainConfig";

// Styles
// Import Font Awesome Icons Set
import 'font-awesome/css/font-awesome.min.css';
// Import Simple Line Icons Set
import 'simple-line-icons/css/simple-line-icons.css';
// Temp fix for reactstrap
import '../scss/core/_dropdown-menu-right.scss';
// Import Swiper css
import 'react-id-swiper/src/styles/scss/swiper.scss';
// Import Simplebar css
import 'simplebar/dist/simplebar.css';
// Import Main styles for this application
import '../scss/style.scss';
// Import Videojs Panaroma style
import 'videojs-panorama/dist/videojs-panorama.min.css';

// Views
import App from './containers/App';
import RootReducer from './reducers/index';

//localisation
import { addLocaleData } from "react-intl";
import locale_en from 'react-intl/locale-data/en';
import locale_be from 'react-intl/locale-data/be';
import locale_id from 'react-intl/locale-data/id';
import locale_it from 'react-intl/locale-data/it';
import locale_se from 'react-intl/locale-data/se';
import locale_ar from "react-intl/locale-data/ar";
import locale_no from "react-intl/locale-data/no";
import locale_fr from "react-intl/locale-data/fr";
import locale_ee from "react-intl/locale-data/ee";
import locale_tr from 'react-intl/locale-data/tr';
import locale_lv from 'react-intl/locale-data/lv';
import locale_lt from 'react-intl/locale-data/lt';
import locale_rs from 'react-intl/locale-data/sr';
import locale_th from 'react-intl/locale-data/th';
import locale_el from "react-intl/locale-data/el";
import locale_de from "react-intl/locale-data/de";
import locale_cs from "react-intl/locale-data/cs";
import locale_es from "react-intl/locale-data/es";
import locale_pt from "react-intl/locale-data/pt";

addLocaleData([...locale_en, ...locale_be, ...locale_id,, ...locale_it, ...locale_tr,...locale_se, ...locale_ar, ...locale_no, ...locale_fr, ...locale_ee, ...locale_lv,...locale_lt,...locale_rs,...locale_th,...locale_el,...locale_de,...locale_cs, ...locale_es, ...locale_pt]);

import messages_en from "./translations/en.json";
import messages_be from "./translations/be.json";
import messages_id from "./translations/id.json";
import messages_it from "./translations/it.json";
import messages_se from "./translations/se.json";
import messages_ar from "./translations/ar.json";
import messages_no from "./translations/no.json";
import messages_fr from "./translations/fr.json";
import messages_ee from "./translations/ee.json";
import messages_tr from "./translations/tr.json";
import messages_lv from "./translations/lv.json";
import messages_lt from "./translations/lt.json";
import messages_rs from "./translations/rs.json";
import messages_th from "./translations/th.json";
import messages_el from "./translations/gr.json";
import messages_de from "./translations/de.json";
import messages_cs from "./translations/cs.json";
import messages_es from "./translations/es.json";
import messages_pt from "./translations/pt.json";

const messages = {
    'en': messages_en,
    'be': messages_be,
    'id': messages_id,
    'it': messages_it,
    'se': messages_se,
    'ar': messages_ar, 
    'no': messages_no,
    'fr': messages_fr,
    'ee': messages_ee,
    'tr': messages_tr,
    'lv': messages_lv,
    'lt': messages_lt,
    'sr': messages_rs,
    'th': messages_th,
    'el': messages_el,
    'de': messages_de,
    'cs': messages_cs,
    'es': messages_es,
    'pt': messages_pt
};

const persistedState = (typeof sessionStorage.getItem('mobiotv') != "undefined") ? JSON.parse(sessionStorage.getItem('mobiotv')) : null;

const connectWithReduxMiddleWare = applyMiddleware(ReduxPromise)(createStore);
// const store = connectWithReduxMiddleWare(RootReducer);
const store = (persistedState != null)? connectWithReduxMiddleWare(RootReducer, persistedState): connectWithReduxMiddleWare(RootReducer);

store.subscribe(() => {
    if(store.getState().AccountReducer.interests.length>0 ){
    sessionStorage.setItem('mobiotv', JSON.stringify(store.getState()));
    }
});

export const addToken = (function() {
    axios.defaults.timeout = 20000;
    let token = store.getState().WelcomeReducer.token;
    if (token) {
        axios.defaults.headers.common['authorization'] = token;
    } else {
        axios.defaults.headers.common['authorization'] = null;
        /*if setting null does not remove `Authorization` header then try
         delete axios.defaults.headers.common['Authorization'];
         */
    }
})();

class LangWrapper extends Component {

    componentWillMount(){
        const h = document.querySelector("html");
        if(config.lang === 'ar'){
            h.setAttribute("dir", "rtl");
            h.setAttribute("lang", "ar");
        }
        else if(config.subDomain === "be"){
            h.setAttribute("lang", "nl")
        }
        else h.setAttribute("lang", config.lang);
    }

    changeLang(event) {
        if (event == 'ar') {
            config.lang = 'ar';
            const h = document.querySelector("html");
            h.setAttribute("dir", "rtl");
            h.setAttribute("lang", "ar");
        }
        else if (event == 'fr') {
            config.lang = 'fr';
            const h = document.querySelector("html");
            h.setAttribute("lang", "fr");
        }
        else if (event == 'de') {
            config.lang = 'de';
            const h = document.querySelector("html");
            h.setAttribute("lang", "de");
        }
        else if (event == 'it') {
            config.lang = 'it';
            const h = document.querySelector("html");
            h.setAttribute("lang", "it");
        }
        else {
            config.lang = 'en';
            const h = document.querySelector("html");
            h.setAttribute("dir", "ltr");
            h.setAttribute("lang", "en");
        }
        this.setState({})
    };



    render() {
        return (
            <IntlProvider locale={config.lang} messages={messages[config.lang]}>
                <HashRouter>
                    <Switch>
                        <App changeLang={this.changeLang.bind(this)} currentLang={config.lang} />
                    </Switch>
                </HashRouter>
            </IntlProvider>)
    }

}

ReactDOM.render(
    <Provider store={store}>
        <LangWrapper />
    </Provider>,
    document.getElementById('root'));




// WEBPACK FOOTER //
// ./src/index.js